import { Bank } from './interfaces';

export const getBankName = ({ bankCode, bankName }: Bank) => bankName || `Unknown (${bankCode})`;
